import PrefetchSizeApprovalStatus from '@/common/models/creative/PrefetchSizeApprovalStatus.enum';
import Validatable from '@/validator/Validatable';

export interface ICreativePrefetchSizeAPI {
  width: number;
  height: number;
  approval: PrefetchSizeApprovalStatus;
}

export default class CreativePrefetchSize extends Validatable {
  width: number;

  height: number;

  approval: PrefetchSizeApprovalStatus;

  constructor(width = 0, height = 0, approval = PrefetchSizeApprovalStatus.PENDING) {
    super();
    this.width = width;
    this.height = height;
    this.approval = approval;
  }

  static fromApi(apiObject: ICreativePrefetchSizeAPI) {
    return new CreativePrefetchSize(apiObject.width, apiObject.height, apiObject.approval);
  }

  static fromObject(obj: CreativePrefetchSize) {
    return super.fromObject(obj, new CreativePrefetchSize());
  }

  toApi(): ICreativePrefetchSizeAPI {
    return {
      width: this.width,
      height: this.height,
      approval: this.approval,
    };
  }
}
